import GroupSearch from '../mw-group-search';

export default class MwPageSearch extends GroupSearch {

  inputPlaceholder = __('Search Pages');

}